import { render, staticRenderFns } from "./Obras_clientes.vue?vue&type=template&id=2818c070&"
import script from "./Obras_clientes.vue?vue&type=script&lang=js&"
export * from "./Obras_clientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports